export * from './supplier-layout.component';
